import styled from "styled-components";
import { color } from "../../../../shared/styles";
import { NavLink } from "react-router-dom";

interface ContentWrapperProps {
    isSelected: boolean;
    isCollasped?: boolean;
}

export const ContentWrapper = styled(NavLink)<ContentWrapperProps>`
    width: ${(props: any) => (props.isCollasped ? "24px" : "224px")};
    height: 26px;
    display: flex;
    gap: 7px;
    font-size: 13px;
    font-weight: 400;
    align-items: center;
    justify-content: ${(props) =>
        props.isCollasped ? "center" : "flex-start"};
    padding: ${(props: any) =>
        props.isCollasped ? "10px 10px 10px 10px" : "10px 18px 10px 18px"};
    border-radius: ${(props: any) => (props.isCollasped ? "50%" : "8px")};
    cursor: pointer;
    white-space: nowrap;
    overflow-x: hidden;
    text-decoration: none;
    transition:
        background-color 0.3s ease,
        color 0.3s ease;

    color: ${(props: any) =>
        props.isSelected ? color.primary.BLUE_B100 : "black"};

    background-color: ${(props: any) =>
        props.isSelected && color.status.INFO_LIGHT};

    &:hover {
        background-color: ${color.status.INFO_LIGHT};
    }
`;
